module.exports = __webpack_public_path__ + "img/unknown.ebcca0c6.png";